export const dedicated = {
  title: 'Dedicated Servers',
  subtitle: 'High-performance dedicated servers for demanding applications',
  features: {
    hardware: {
      title: 'Premium Hardware',
      description: 'Latest generation Intel and AMD processors'
    },
    security: {
      title: 'Advanced Security',
      description: 'DDoS protection up to 4 Tbps included'
    },
    performance: {
      title: 'High Performance',
      description: 'NVMe storage and 10Gbps network'
    }
  },
  plans: {
    title: 'Available Servers',
    falkenstein: {
      servers: [
        {
          title: 'Intel i9 Server',
          price: '€76.99',
          specs: [
            'Intel Core™ i9-9900K',
            '64 GB DDR4',
            '2 x 1TB NVMe SSD',
            'Unlimited bandwidth (fair-use)',
            '1Gbps uplink',
            '24/7 support',
            'Advanced DDoS Protection (4Tbps+)'
          ]
        },
        {
          title: 'AMD Ryzen 5 Server',
          price: '€84.99',
          specs: [
            'AMD Ryzen™ 5 3600',
            '64 GB DDR4',
            '2 x 512GB NVMe SSD',
            'Unlimited bandwidth (fair-use)',
            '1Gbps uplink',
            '24/7 support',
            'Advanced DDoS Protection (4Tbps+)'
          ]
        },
        {
          title: 'Intel i5 Server',
          price: '€84.99',
          specs: [
            'Intel Core™ i5-12500',
            '64 GB DDR4',
            '2 x 512GB NVMe SSD',
            'Unlimited bandwidth (fair-use)',
            '1Gbps uplink',
            '24/7 support',
            'Advanced DDoS Protection (4Tbps+)'
          ]
        },
        {
          title: 'AMD Ryzen 9 Pro',
          price: '€119.99',
          specs: [
            'AMD Ryzen™ 9 7950X3D',
            '128GB DDR4',
            '2 x 2TB NVMe SSD',
            'Unlimited bandwidth (fair-use)',
            '1Gbps uplink',
            '24/7 support',
            'Advanced DDoS Protection (4Tbps+)'
          ]
        },
        {
          title: 'AMD Ryzen 9 Enterprise',
          price: '€169.99',
          specs: [
            'AMD Ryzen™ 9 7950X3D',
            '128GB DDR4',
            '2 x 4TB NVMe SSD',
            'Unlimited bandwidth (fair-use)',
            '1Gbps uplink',
            '24/7 support',
            'Advanced DDoS Protection (4Tbps+)'
          ]
        }
      ]
    }
  }
};
